document.addEventListener("turbolinks:load", () => {
  $('.close-notification').click(function() {
    $('.notification').remove();
  })
});